import { Grid, styled } from "@mui/material";
import { theme } from "@racwa/react-components";

export const StyledGrid = styled(Grid)({
  justifyContent: "center",
  [theme.breakpoints.up("sm")]: {
    maxWidth: "600px",
  },
});
